<template>
    
    <div class="row hp-authentication-page">
        <div class="hp-bg-black-20 hp-bg-color-dark-90 col-lg-6 col-12 mm-none">
            <div class="row hp-image-row h-100 px-8 px-sm-16 px-md-0 pb-32 pb-sm-0 pt-32 pt-md-0">
                <div class="hp-logo-item m-16 m-sm-32 m-md-64 w-auto px-0 col-12">
                    <!-- <div class="hp-header-logo d-flex align-items-center">
                        <a href="#" class="position-relative">

                            <img class="hp-logo hp-sidebar-visible hp-dark-none" src="./img/favicon.png" alt="logo">
                            <img class="hp-logo hp-sidebar-visible hp-dark-block" src="./img/favicon.png" alt="logo">
                            
                            <img class="hp-logo hp-sidebar-hidden hp-dir-none hp-dark-block" src="./img/favicon.png" alt="logo">
                            <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-none" src="./img/favicon.png" alt="logo">
                            <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-block" src="./img/favicon.png" alt="logo">
                        </a>

                        <a href="#" target="_blank" class="d-flex">
                            <span class="hp-sidebar-hidden hp-caption fw-normal hp-text-color-primary-1">v.1.0</span>
                        </a>
                    </div> -->
                </div>

                <div class="col-12 px-0">
                    <div class="row h-100 w-100 mx-0 align-items-center justify-content-center bg-1" style="background-size: cover; background-repeat: no-repeat; background-position: start;">
                        <div class="hp-bg-item text-center mb-32 mb-md-0 px-0 col-12">
                            <div style="display: flex; justify-content: center; align-items: center; margin-top: 400px;">
                                <img src="../assets/img/logo_big.png" alt="" width="120px">
                                <h1 class="titleH" style="text-align: center; color: #fff; font-size: 90px; margin-top: 50px; margin-left: -25px;">aesnap</h1>
                            </div>
                        </div>

                        <div class="hp-text-item text-center col-xl-9 col-12">
                            <h2 class="hp-text-color-blac-100 hp-text-color-dark-0 mx-16 mx-lg-0 mb-16" style="color: #fff;"> </h2>
                            <p class="h4 mb-0 fw-normal hp-text-color-blac-80 hp-text-color-dark-30" style="color: #fff;"></p>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="col-12 col-lg-6 py-sm-64 py-lg-0">
            <div class="row align-items-center justify-content-center h-100 mx-4 mx-sm-n32">
                <div class="col-12 col-md-9 col-xl-7 col-xxxl-5 px-8 px-sm-0 pt-24 pb-48">

                    <h1 class="mb-0 mb-sm-24 mainTitle mm-none titleH" style="margin-top: 50px; " >Reset Password</h1>
                    <h1 class="mb-0 mb-sm-24 mainTitle dd-none titleH" style="margin-top: -80px; " >Reset Password</h1>

                    <p class=" text-black-60 subTitle" style=" margin-bottom: 50px;"></p>
                    

                    <form class="mt-16 mt-sm-32 mb-8" @submit.prevent="submit">

                        <div class="mb-16" style="position: relative;">
                            <label for="password" class="form-label" >New password </label>
                            <input type="text" class="form-control" id="password" style="padding-top: 5px; padding-bottom: 5px;" placeholder="Minimum of 8 characters" v-model="newPassword">
                            <div style="position: absolute; cursor: pointer; top: 45px; right: 20px;">
                                <i class="hp-text-color-dark-0 iconly-Light-Show" id="showIcon" @click="passwordMethod"></i>
                                <i class="hp-text-color-dark-0 iconly-Light-Hide" id="hideIcon" @click="passwordMethod"></i>
                            </div>
                        </div>

                        <div class="mb-16" style="position: relative;">
                            <label for="password2" class="form-label" >Repeat new password </label>
                            <input type="text" class="form-control" id="password2" style="padding-top: 5px; padding-bottom: 5px;" placeholder="Minimum of 8 characters" v-model="confirmNewPassword">
                            <div style="position: absolute; cursor: pointer; top: 45px; right: 20px;">
                                <i class="hp-text-color-dark-0 iconly-Light-Show" id="showIcon2" @click="passwordMethod2"></i>
                                <i class="hp-text-color-dark-0 iconly-Light-Hide" id="hideIcon2" @click="passwordMethod2"></i>
                            </div>
                        </div>

                        

                        <button type="submit" class="btn btn-primary w-100" style="color: #fff; margin-top: 30px; padding-top: 20px; padding-bottom: 20px; font-size: larger;">
                            Submit
                        </button>
                    </form>

                    <div class="col-12 hp-form-info text-center" style="margin-top: 20px;">
                        <p>Not a member yet? <router-link :to="{name: 'sign-up'}" class="hp-text-color-dark-primary-2" style="color: #9146ff;"><strong>Sign up</strong></router-link></p>
                        
                    </div>

                    <div class="mt-48 mt-sm-96 col-12">

                        <div class="dd-none" style="margin-top: 100px;"></div>
                        <div class=" divider mt-18 mb-24" ></div>

                        <div style="display: flex; justify-content: space-evenly; align-items: center; width: 100%;">
                

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/privacy" target="_blank">Privacy</a>
                            </p>

                            <p class="hp-badge-text">•</p>

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/terms" target="_blank">Terms</a>
                            </p>

                            <p class="hp-badge-text">•</p>

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/complaints" target="_blank">Complaints</a>
                            </p>

                        </div>

                        
                    </div>
                    
                </div>
            </div>
        </div>
    </div>

    <!-- MODALS -->
    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>

<style scoped>

    .bg-1{
        background-image: url(../assets/img/frontpage-banner-7.png);
    }

</style>

<script>

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc } from "firebase/firestore"; 
    import {getAuth, EmailAuthProvider, reauthenticateWithCredential, updatePassword, signInWithEmailAndPassword} from "firebase/auth"
    import { db } from '@/firebase';
    import { MD5 } from "md5-js-tools";

    export default {

        data(){
            return{
                loadingText: "",
                errorText: "",
                successText: "",

                currentPassword: "",
                newPassword: "",
                confirmNewPassword: "",
            }
        },

        mounted(){

            this.passwordMethod();
            this.passwordMethod2();
            this.getPwrd();
        },

        methods:{
            textToBin(minput) {

                let input = minput.trim();

                let output = "";
                for (var i = 0; i < input.length; i++) {
                    output += input[i].charCodeAt(0).toString(2) + " ";
                }

                return output;
            },

            binToText(minput) {
                let input = minput.trim();
                return input.split(" ").map(function(elem) {
                    return String.fromCharCode(parseInt(elem, 2));
                }).join("")
            },

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.push({name: 'sign-in'});
            },

            passwordMethod(){

                let passwordInput = document.getElementById("password");
                let showIcon = document.getElementById("showIcon");
                let hideIcon = document.getElementById("hideIcon");

                if (passwordInput.type === "password") {
                    passwordInput.type = "text";
                    showIcon.style.display = 'none';
                    hideIcon.style.display = 'block';
                } 
                else {
                    passwordInput.type = "password";
                    showIcon.style.display = 'block';
                    hideIcon.style.display = 'none';
                }

            },

            passwordMethod2(){

                let passwordInput = document.getElementById("password2");
                let showIcon = document.getElementById("showIcon2");
                let hideIcon = document.getElementById("hideIcon2");

                if (passwordInput.type === "password") {
                    passwordInput.type = "text";
                    showIcon.style.display = 'none';
                    hideIcon.style.display = 'block';
                } 
                else {
                    passwordInput.type = "password";
                    showIcon.style.display = 'block';
                    hideIcon.style.display = 'none';
                }

            },

            async getPwrd(){

                if(sessionStorage.getItem("fEmail") == null){
                    return;
                }

                const q = query(collection(db, "Users"), where("email", "==", sessionStorage.getItem("fEmail")));

                const querySnapshot = await getDocs(q);
                if(querySnapshot.docs.length > 0){
                
                    querySnapshot.forEach((doc) => {

                        this.currentPassword = doc.data().psw;

                    });
            
                    this.signIn();

                }
            },

            signIn(){

                const auth = getAuth();

                signInWithEmailAndPassword(auth, sessionStorage.getItem("fEmail"), this.currentPassword)
                .then(async (data)=>{

                    //check 2fa
                    
                })

                .catch((error)=>{
                    console.log(error.code);
                    switch(error.code){
                        case "auth/invalid-email":
                            console.log(error);
                            break;
                        
                        case "auth/user-not-found":
                            console.log(error);
                            break;   
                        
                        case "auth/wrong-password":
                            console.log(error);
                            break;   
                        
                        default:
                            console.log(error);
                            break;    


                    }
                })

                

            },

            submit(){

                this.loadingText = "Updating password...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                if(this.newPassword.length < 8){

                    this.errorText = "Password must be at least 8 characters long";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;

                }

                if(this.newPassword != this.confirmNewPassword){

                    this.errorText = "Passwords do not match...";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;

                }

                let passwordHash = MD5.generate(String(this.newPassword));

                const user = auth.currentUser;
                const credential = EmailAuthProvider.credential(
                sessionStorage.getItem("fEmail"), this.currentPassword );

                reauthenticateWithCredential(user, credential)
                .then((result) => {
                    //password correct
                    updatePassword(user, passwordHash).then(() => {
                        // Update successful
                        this.successText = "Password was updated successfully.";
                        this.$refs.successModal.classList.add("bg-active");
                        this.$refs.loadingModal.classList.remove("bg-active");

                    }).catch((error) => {
                        // An error occurred
                        console.log(error);
                        this.errorText = "An error occured while updating your password...";
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.errorModal.classList.add("bg-active");
                        return;
                    });

                })
                .catch((error) => {
                    
                    this.errorText = "Incorrect password...";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;

                });

            }


        }
        
        

    }

</script>